/**
 * Icons reference table:
 * https://www.figma.com/file/G68ZqEcJtBwPQi9KdmApqi/00-%E2%80%93-Design-System?node-id=0%3A144
 */
export const icons = [
  'office-space',
  'virtual-office',
  'coworking-desk',
  'meeting-room',
  'by-plane',
  'by-train',
  'by-car',
  'walk',
  'distance',
  'tfl',
  'open-247',
  'hour-cctv',
  'airport-location',
  'business-lounge',
  'breakout-area',
  'business-park',
  'town-centre',
  'bike-store',
  'food-service',
  'suspended-ceilings',
  'raised-floors',
  'wheelchair-facilities',
  'childcare',
  'lift',
  'workout-room',
  'transport-links',
  'cafe',
  'coffee-bar',
  'vending-machines',
  'smoking-area',
  'event-space',
  'outdoor-terrace',
  'cleaning-service',
  'wifi',
  'printer',
  'phonebooth',
  'video-conferencing',
  'parking',
  'shower-room',
  'contact',
  'pin-lines',
  'check',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'chevron-down',
  'arrow-left',
  'arrow-right',
  'plus',
  'tooltip-1',
  'tooltip-2',
  'success',
  'error',
  'star',
  'pdf',
  'marker',
  'pin-black',
];
